import { render, staticRenderFns } from "./AdminUPT.vue?vue&type=template&id=19deb687&"
import script from "./AdminUPT.vue?vue&type=script&lang=js&"
export * from "./AdminUPT.vue?vue&type=script&lang=js&"
import style0 from "./AdminUPT.vue?vue&type=style&index=0&id=19deb687&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports